import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

const MyGamesDashboardSection = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const [expandedSections, setExpandedSections] = useState({
    0: true,
    200: true,
    300: true,
  });

  const steps = [
    {
      title: "My Games Dashboard",
      level: 0,
      id: 100,
      image: "/assets/guide/auth/my_games/my_games_dashboard.png",
    },
    { title: "Game Board", level: 0, isHeader: true, id: 200 },
    {
      title: "Game Board View",
      level: 1,
      parentId: 200,
      image: "/assets/guide/auth/my_games/game_board.png",
      description:
        "The primary game interface where you track movement and events. All board updates, including team positions and dice rolls, are processed in real-time via Socket.IO to ensure a synchronized experience for all players.",
    },
    {
      title: "Game Board Actions",
      level: 1,
      parentId: 200,
      isHeader: true,
      id: 300,
    },
    {
      title: "Roll Dice",
      level: 2,
      parentId: 300,
      image: "/assets/guide/auth/my_games/roll_dice.png",
      description: "Click to generate your move and progress across the board.",
    },
    {
      title: "Revert Roll Warning",
      level: 2,
      parentId: 300,
      image: "/assets/guide/auth/my_games/revert_roll_modal.png",
      description:
        "Review your decision. This modal confirms you want to undo your last move.",
    },
    {
      title: "Reversion Complete",
      level: 2,
      parentId: 300,
      image: "/assets/guide/auth/my_games/reverted.png",
      description:
        "Your turn has been successfully reverted to the previous position.",
    },
  ];

  const toggleSection = (id) =>
    setExpandedSections((prev) => ({ ...prev, [id]: !prev[id] }));

  const navigate = (direction) => {
    let nextIndex = stepIndex + direction;
    while (nextIndex >= 0 && nextIndex < steps.length) {
      if (!steps[nextIndex].isHeader) {
        setStepIndex(nextIndex);
        return;
      }
      nextIndex += direction;
    }
  };

  const isVisible = (step) => {
    if (step.level === 0) return true;
    return expandedSections[step.parentId];
  };

  return (
    <div className="guide-layout">
      <nav className="sub-nav">
        {steps.map((step, idx) => {
          const show = isVisible(step);
          const isHeader = !!step.isHeader;
          return (
            <div
              key={idx}
              className={`nav-item-wrapper ${stepIndex === idx ? "active" : ""}`}
              style={{
                maxHeight: show ? "60px" : "0px",
                opacity: show ? 1 : 0,
              }}
            >
              <span
                className={`sub-nav-item level-${step.level} ${isHeader ? "sub-nav-header" : ""}`}
                onClick={() =>
                  isHeader ? toggleSection(step.id) : setStepIndex(idx)
                }
              >
                {isHeader && (
                  <ChevronRight
                    size={16}
                    style={{
                      marginRight: "8px",
                      transform: expandedSections[step.id]
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                    }}
                  />
                )}
                {step.title}
              </span>
            </div>
          );
        })}
      </nav>

      <main className="guide-main">
        <div className="guide-item">
          <div className="guide-text">
            <h2>{steps[stepIndex].title}</h2>
            <div className="nav-controls">
              <button disabled={stepIndex === 0} onClick={() => navigate(-1)}>
                Back
              </button>
              <button
                disabled={stepIndex === steps.length - 1}
                onClick={() => navigate(1)}
                style={{ marginLeft: "10px" }}
              >
                {stepIndex === steps.length - 1 ? "Finish" : "Next"}
              </button>
            </div>
            {!steps[stepIndex].isHeader && (
              <div className="guide-text-wrapper">
                <p className="step-description">
                  {steps[stepIndex].description}
                </p>
              </div>
            )}
          </div>
          {!steps[stepIndex].isHeader && (
            <div className="screenshot-container">
              <img src={steps[stepIndex].image} alt={steps[stepIndex].title} />
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default MyGamesDashboardSection;
